// iter154.3 — GEO: hreflang, canonical, LocalBusiness JSON-LD tüm public sayfalarda
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { api } from "../../lib/api";
import { preloadShopTree } from "../../hooks/useShopTree";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import MobileDock from "./MobileDock";
import WhatsAppFloat from "./WhatsAppFloat";

let _lbCache = null;

export default function PublicLayout() {
  const { pathname } = useLocation();

  // iter156: shop tree'yi mount'ta prefetch (header + footer + home hepsi kullanacak)
  useEffect(() => { preloadShopTree(); }, []);

  // Path-agnostic head injection: hreflang, canonical, LocalBusiness JSON-LD
  useEffect(() => {
    const origin = window.location.origin;
    const canonical = origin + pathname;
    const setLink = (rel, href, extra = {}) => {
      const selectorExtra = extra.hreflang ? `[hreflang="${extra.hreflang}"]` : "";
      let el = document.querySelector(`link[rel="${rel}"]${selectorExtra}`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        Object.entries(extra).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };
    setLink("canonical", canonical);
    setLink("alternate", canonical, { hreflang: "tr-TR" });
    setLink("alternate", canonical, { hreflang: "tr" });
    setLink("alternate", canonical, { hreflang: "x-default" });
    // OG url
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) { ogUrl = document.createElement("meta"); ogUrl.setAttribute("property", "og:url"); document.head.appendChild(ogUrl); }
    ogUrl.setAttribute("content", canonical);
    // Locale
    let ogLocale = document.querySelector('meta[property="og:locale"]');
    if (!ogLocale) { ogLocale = document.createElement("meta"); ogLocale.setAttribute("property", "og:locale"); document.head.appendChild(ogLocale); }
    ogLocale.setAttribute("content", "tr_TR");
    // Robots (default)
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
    robots.setAttribute("content", "index, follow, max-image-preview:large, max-snippet:-1");
  }, [pathname]);

  // Inject LocalBusiness + WebSite JSON-LD once
  useEffect(() => {
    if (_lbCache) return;
    api.get("/seo/schema/localbusiness")
      .then(res => {
        _lbCache = res.data;
        // Remove existing then re-inject
        document.querySelectorAll('script[data-geo-schema="localbusiness"]').forEach(n => n.remove());
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-geo-schema", "localbusiness");
        s.textContent = JSON.stringify(res.data);
        document.head.appendChild(s);
        // Additionally inject WebSite schema with SearchAction
        const ws = document.createElement("script");
        ws.type = "application/ld+json";
        ws.setAttribute("data-geo-schema", "website");
        ws.textContent = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "url": window.location.origin,
          "name": "Bordo Seramik",
          "potentialAction": {
            "@type": "SearchAction",
            "target": window.location.origin + "/urunler?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        });
        document.head.appendChild(ws);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicHeader />
      <main className="flex-1 pb-20 md:pb-0"><Outlet /></main>
      <PublicFooter />
      <MobileDock />
      <WhatsAppFloat />
    </div>
  );
}
